// Module
var code = "<div class=\"dms-usergridconfig\">\r\n</div>";
// Exports
export default code;